const defaultTitle = 'Para seu Pet';

export const PAGE_TITLE = {
  base: `${defaultTitle}`,
  home: `${defaultTitle} | Início`,
  televet: `${defaultTitle} | Teleconsulta`,
  cremation: `${defaultTitle} | Proteção Pet`,
  assistance: `${defaultTitle} | Assistência Pet`,
};
